import type { Pinia } from "pinia";
import { useUserStore } from "~/stores/user";
import { getOAuthUser } from "~/utils/oauthUserStorage";

export default defineNuxtPlugin({
  name: "user-init",
  enforce: "post",
  setup(nuxtApp) {
    const pinia = nuxtApp.$pinia as Pinia | undefined;
    if (!pinia) return;
    nuxtApp.hook("app:mounted", () => {
      const userStore = useUserStore(pinia);
      const user = getOAuthUser();
      if (user) {
        userStore.setUser(user);
      }
    });
  },
});
